<ng-container *ngIf="permConfig.isAddAllowed">
  <div class="container-fluid">
    <app-page-title title="Zone Linking"></app-page-title>
    <form [formGroup]="zoneForm" (ngSubmit)="uploadZoneLinks()" (keydown.enter)="$event.preventDefault()">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-2">
                    <label for="vendor" class="form-label">Vendor <span class="mandatory">*</span></label>
                    <ng-select id="vendor" placeholder="Select" formControlName="ddlVendor" [appendTo]="'body'" [openOnEnter]="false"
                      [items]="vendorList" bindLabel="name" [bindValue]="'id'"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{'is-invalid': (isFormSubmitted || zoneForm.get('ddlVendor').dirty) && zoneForm.get('ddlVendor').errors }" >
                    </ng-select>
                    <div
                      *ngIf="(isFormSubmitted || zoneForm.get('ddlVendor').dirty) && zoneForm.get('ddlVendor').errors"
                      class="invalid-feedback">
                      <span *ngIf="zoneForm.get('ddlVendor').errors.required">Vendor is required</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-0"></label>
                  <div class="">
                    <button type="button" class="btn btn-primary btn-sm d-flex" [disabled]="isDownloading"
                      [class.isdisable]="isDownloading" (click)="downloadFormatFile()" >
                      <i class="bx bx-download font-size-16 me-2"></i> Download </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="fromDate" class="form-label">From Date <span class="mandatory">*</span></label>
                    <input id="fromDate" class="form-control form-control-sm" type="date" formControlName="txtFromDate"
                      [ngClass]="{'is-invalid': (isFormSubmitted || zoneForm.get('txtFromDate').touched) && zoneForm.get('txtFromDate').errors }" >
                  </div>
                  <div
                    *ngIf="(isFormSubmitted || zoneForm.get('txtFromDate').touched) && zoneForm.get('txtFromDate').errors"
                    class="invalid-feedback">
                    <span *ngIf="zoneForm.get('txtFromDate').errors.required">From date is required</span>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="toDate" class="form-label">To Date <span class="mandatory">*</span></label>
                    <input id="toDate" class="form-control form-control-sm" type="date" formControlName="txtToDate"
                      [ngClass]="{'is-invalid': (isFormSubmitted || zoneForm.get('txtToDate').touched) && zoneForm.get('txtToDate').errors }" >
                  </div>

                  <div
                    *ngIf="(isFormSubmitted || zoneForm.get('txtFromDate').touched) && zoneForm.get('txtFromDate').errors"
                    class="invalid-feedback">
                    <span *ngIf="zoneForm.get('txtFromDate').errors.required">To date is required</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <label class="form-label"> ( <small
                    for="signatorylogo"><i class="mdi mdi-information">Note: .xls are only allowed.</i></small> )</label>
                  <div class="input-group">
                    <input type="file" class="form-control form-control-sm" accept=".xlsx,.xls"
                      id="importzones"
                      formControlName="fileControl" (change)="onChangeFileSelect($event)"
                      [ngClass]="{'is-invalid': (isFormSubmitted || zoneForm.get('fileControl').touched) && zoneForm.get('fileControl').errors}" >
                    <button type="button" class="btn btn-primary btn-sm d-flex" 
                        (click)="uploadZoneLinks()" (keydown.enter)="useEnterKey ? $event.preventDefault() : uploadZoneLinks()"
                        >
                      <i class="bx bx-upload font-size-16 me-2"></i> Upload </button>
                    <div
                      *ngIf="(isFormSubmitted || zoneForm.get('fileControl').touched) && zoneForm.get('fileControl').errors"
                      class="invalid-feedback">
                      <span *ngIf="zoneForm.get('fileControl').errors.required">Select file to upload</span>
                    </div>
                  </div>
                  <div *ngIf="showProgressBar" class="progress mt-2">
                    <div class="progress-bar progress-bar-striped" role="progressbar"
                        [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin="0"
                        aria-valuemax="100">
                        {{progress}}%
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="zoneLinkAddForm">
      <!-- <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-transparent border-bottom text-uppercase"> Zone Linking </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="code" class="form-label">Zone<span class="mandatory">*</span></label>
                    <ng-select [items]="zoneList" bindLabel="zonecode" [bindValue]="'zonecode'"
                      formControlName="ddlZone" [appendTo]="'body'" [openOnEnter]="false" placeholder="Select"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{'is-invalid': (isZoneAddFormSubmitted || zoneLinkAddForm.get('ddlZone').touched) && zoneLinkAddForm.get('ddlZone').errors }"></ng-select>
                    <div
                      *ngIf="(isZoneAddFormSubmitted || zoneLinkAddForm.get('ddlZone').touched) && zoneLinkAddForm.get('ddlZone').errors"
                      class="invalid-feedback">
                      <span *ngIf="zoneLinkAddForm.get('ddlZone').errors.required">Zone is required</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="country" class="form-label">Country <span class="mandatory">*</span></label>
                    <ng-select id="country" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="countryList"
                      bindLabel="name" [bindValue]="'isocode'" (change)="onCountryChange()" formControlName="ddlCountry"
                      [ngClass]="{'is-invalid': (isZoneAddFormSubmitted || zoneLinkAddForm.get('ddlCountry').touched) && zoneLinkAddForm.get('ddlCountry').errors}">
                    </ng-select>
                    <div
                      *ngIf=" (isZoneAddFormSubmitted || zoneLinkAddForm.get('ddlCountry').touched) && zoneLinkAddForm.get('ddlCountry').errors"
                      class="invalid-feedback">
                      <span *ngIf="zoneLinkAddForm.get('ddlCountry').errors.required">Country is required</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="country" class="form-label">State</label>
                    <ng-select id="state" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="stateList" bindLabel="name"
                      [bindValue]="'isocode'" (change)="onStateChange()" formControlName="ddlState"
                      [ngClass]="{'is-invalid':(isZoneAddFormSubmitted || zoneLinkAddForm.get('ddlState').touched) && zoneLinkAddForm.get('ddlState').errors}">
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="country" class="form-label">City</label>
                    <ng-select id="city" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="cityList" bindLabel="name"
                      [bindValue]="'isocode'" formControlName="ddlCity"
                      [ngClass]="{'is-invalid': (isZoneAddFormSubmitted || zoneLinkAddForm.get('ddlCity').touched) && zoneLinkAddForm.get('ddlCity').errors}">
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="code" class="form-label">Product</label>
                    <ng-select placeholder="Select" [items]="productList" bindLabel="name" [bindValue]="'code'"
                      formControlName="ddlProduct" [appendTo]="'body'" [openOnEnter]="false"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{'is-invalid':(isZoneAddFormSubmitted ||zoneLinkAddForm.get('ddlProduct').touched) && zoneLinkAddForm.get('ddlProduct').errors}"></ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="uploaddoc" class="form-label"></label>
                    <div *ngIf="!isEdit">
                      <button type="submit" class="btn btn-primary btn-sm d-flex" (click)=" addZone()"
                        [disabled]="isZoneAdd" [class.isdisable]="isZoneAdd">
                        <i class="bx bx-plus font-size-16 me-2"></i> Add </button>
                    </div>
                    <div *ngIf="isEdit">
                      <button type="button" class="btn btn-primary btn-sm" (click)="isEdit = false; updateZone()">
                        Update </button>
                      <button type="button" class="btn btn-secondary btn-sm" (click)="isEdit = false; resetZone()">
                        Cancel </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mt-2">
                  <div class="col-md-12 grid-container">
                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                      [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                      [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true"
                      (gridReady)="onGridReady($event)" [gridOptions]="gridOptions">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="card">
          <div class="card-header bg-transparent border-bottom text-uppercase">Zone Periods</div>
          <div class="card-body">
            <div class="col-md-12">
              <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                [rowData]="rowDataPeriod" [columnDefs]="columnDefsPeriod" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true"
                (gridReady)="onGridReadyPeriod($event)" [gridOptions]="gridOptionsPeriod" [rowSelection]="'single'">
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="showRateDetails">
        <div class="card">
          <div class="card-header bg-transparent border-bottom text-uppercase">Zone Details</div>
          <div class="card-body">
            <div class="col-md-12">
              <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true"
                (gridReady)="onGridReady($event)" [gridOptions]="gridOptions">
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
  <app-forbidden></app-forbidden>
</ng-container>